import styled, {css} from 'styled-components'

export const StyledUpdateCreditCardModalContainer = styled.div`
    ${({theme: {spacing, mediaQueries}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
        height: min-content;
        padding: ${spacing / 2}px ${spacing}px ${spacing * 2}px ${spacing}px;
        ${mediaQueries.m} {
            padding: ${spacing / 2}px ${spacing * 3}px ${spacing * 3}px ${spacing * 3}px;
        }
    `}
`
export const StyledUpdateCreditCardModalDescription = styled.span`
    text-align: center;
`

export const StyledErrorContainer = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        width: 100%;
        padding: 8px 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: ${spacing}px;

        border-radius: 8px;
        border: 1px solid #6a1d1d;
        background: rgba(255, 0, 0, 0.15);
        & h3 {
            color: #00063d;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 19.6px; /* 140% */
        }
        & span {
            color: #22253f;
            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16.8px; /* 140% */
        }
    `}
`
